import { useMemo } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { cn } from "@/lib/utils";
import { richTextIsEmpty } from "@/lib/richText";

/**
 * Shared rich-text editor for term meanings (admin Add/Edit dialogs).
 * Emits HTML; an empty document is normalised to "" so "has a meaning?"
 * checks elsewhere keep working. Render the saved HTML with the matching
 * `jl-rich-content` class — see {@link sanitizeRichHtml}.
 */

const TOOLBAR = [
  [{ header: [1, 2, 3, false] }],
  ["bold", "italic", "underline", "strike"],
  [{ color: [] }, { background: [] }],
  [{ list: "ordered" }, { list: "bullet" }],
  ["blockquote", "link"],
  ["clean"],
];

const FORMATS = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "color",
  "background",
  "list",
  "blockquote",
  "link",
];

interface RichTextFieldProps {
  value: string;
  onChange: (html: string) => void;
  placeholder?: string;
  /** Apply Devanagari/Gujarati font to the editing surface. */
  indic?: boolean;
  className?: string;
}

export function RichTextField({
  value,
  onChange,
  placeholder,
  indic = false,
  className,
}: RichTextFieldProps) {
  const modules = useMemo(() => ({ toolbar: TOOLBAR }), []);

  return (
    <div
      className={cn(
        "jl-rich-editor",
        indic && "jl-rich-editor--indic",
        className
      )}
    >
      <ReactQuill
        theme="snow"
        value={value}
        onChange={html => onChange(richTextIsEmpty(html) ? "" : html)}
        placeholder={placeholder}
        modules={modules}
        formats={FORMATS}
      />
    </div>
  );
}
